export default "__VITE_ASSET__sFPk0Ndv__"